/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationResponseDetails } from './ClaimReservationResponseDetails';
import {
    ClaimReservationResponseDetailsFromJSON,
    ClaimReservationResponseDetailsFromJSONTyped,
    ClaimReservationResponseDetailsToJSON,
} from './ClaimReservationResponseDetails';
import type { Timeslot } from './Timeslot';
import {
    TimeslotFromJSON,
    TimeslotFromJSONTyped,
    TimeslotToJSON,
} from './Timeslot';

/**
 * 
 * @export
 * @interface ClaimReservationWithTimeslot
 */
export interface ClaimReservationWithTimeslot {
    /**
     * 
     * @type {boolean}
     * @memberof ClaimReservationWithTimeslot
     */
    claimFormAuthorized?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimReservationWithTimeslot
     */
    claimFormReceived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimReservationWithTimeslot
     */
    claimFormId?: string | null;
    /**
     * 
     * @type {ClaimReservationResponseDetails}
     * @memberof ClaimReservationWithTimeslot
     */
    claimReservationDetails: ClaimReservationResponseDetails;
    /**
     * 
     * @type {Timeslot}
     * @memberof ClaimReservationWithTimeslot
     */
    timeslot: Timeslot;
    /**
     * 
     * @type {Date}
     * @memberof ClaimReservationWithTimeslot
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimReservationWithTimeslot
     */
    id: string;
}

/**
 * Check if a given object implements the ClaimReservationWithTimeslot interface.
 */
export function instanceOfClaimReservationWithTimeslot(value: object): value is ClaimReservationWithTimeslot {
    if (!('claimReservationDetails' in value) || value['claimReservationDetails'] === undefined) return false;
    if (!('timeslot' in value) || value['timeslot'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ClaimReservationWithTimeslotFromJSON(json: any): ClaimReservationWithTimeslot {
    return ClaimReservationWithTimeslotFromJSONTyped(json, false);
}

export function ClaimReservationWithTimeslotFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservationWithTimeslot {
    if (json == null) {
        return json;
    }
    return {
        
        'claimFormAuthorized': json['claimFormAuthorized'] == null ? undefined : json['claimFormAuthorized'],
        'claimFormReceived': json['claimFormReceived'] == null ? undefined : json['claimFormReceived'],
        'claimFormId': json['claimFormId'] == null ? undefined : json['claimFormId'],
        'claimReservationDetails': ClaimReservationResponseDetailsFromJSON(json['claimReservationDetails']),
        'timeslot': TimeslotFromJSON(json['timeslot']),
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
    };
}

export function ClaimReservationWithTimeslotToJSON(value?: ClaimReservationWithTimeslot | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimFormAuthorized': value['claimFormAuthorized'],
        'claimFormReceived': value['claimFormReceived'],
        'claimFormId': value['claimFormId'],
        'claimReservationDetails': ClaimReservationResponseDetailsToJSON(value['claimReservationDetails']),
        'timeslot': TimeslotToJSON(value['timeslot']),
        'createdAt': ((value['createdAt']).toISOString()),
        'id': value['id'],
    };
}

